import { ChevronRight } from "lucide-react";

const STEPS = ["Connect", "Select data", "Scan", "Identify PII", "Map DPDP", "View risks", "Remediate"];

export const FlowSteps = ({ active = 0 }) => (
  <ol className="mb-5 flex flex-wrap items-center gap-1 text-xs" data-testid="discovery-flow-steps">
    {STEPS.map((s, i) => (
      <li key={s} className="flex items-center gap-1">
        <span className={`rounded-full border px-2.5 py-1 ${i <= active ? "border-blue-600 bg-blue-600 text-white" : "border-slate-200 bg-white text-slate-500"}`}>{i + 1}. {s}</span>
        {i < STEPS.length - 1 && <ChevronRight className="h-3 w-3 text-slate-300" />}
      </li>
    ))}
  </ol>
);
